import {createContext} from 'react';

export const ServerContext = createContext();